///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
export class DpTransparentKorisnik {
    public SifKor: number;
    public NazKor: string;
    public Ulica: string;
    public PosBro: number;
    public Mjesto: string;
    public OIB: string;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/data/dp-transparent/korisnik.model.ts